import General from './General_ammonium_nitrate.jpg'
import Adblue from './AdBlue.jpg';
import urea from './urea.jpg';

let Description_ShopCategory = [
    {
        category: 'General',
        images: [General],
        description: 'description_General'
    },
    {
        category: 'AdBlue',
        images: [Adblue],
        description: 'description_AdBlue'
    },
    {
        category: 'MineralFertilizers',
        images: [urea],
        description: 'description_MineralFertilizers'
    },
]

export default Description_ShopCategory;